// extracted by mini-css-extract-plugin
export default {"discover-breadcrumbs":"BreadCrumbs-module__discover-breadcrumbs___3IwsQ","breadcrumb-container":"BreadCrumbs-module__breadcrumb-container___y-0ge"};